import { Howl, Howler } from 'howler';
import * as i0 from "@angular/core";
var SoundService = /** @class */ (function () {
    function SoundService() {
        var _this = this;
        this.songs = new Map();
        this.soundFX = new Map();
        Howler.volume(0.5);
        Object.keys(Music).filter(function (key) { return !isNaN(Number(key)); }).map(function (value) { return Music.getFromValue(Number(value)); }).forEach(function (song) {
            var howl = new Howl({
            // TODO: set correct options here.
            });
            _this.songs.set(song, howl);
        });
    }
    SoundService.ngInjectableDef = i0.defineInjectable({ factory: function SoundService_Factory() { return new SoundService(); }, token: SoundService, providedIn: "root" });
    return SoundService;
}());
export { SoundService };
export var Music;
(function (Music) {
    Music[Music["FULL_TEMPEST"] = 0] = "FULL_TEMPEST";
    Music[Music["PANJSHIR"] = 1] = "PANJSHIR";
    Music[Music["THE_QUEEN"] = 2] = "THE_QUEEN";
    Music[Music["THE_HANDSOME_PRINCE"] = 3] = "THE_HANDSOME_PRINCE";
})(Music || (Music = {}));
// May need to convert these to sound sprites. Not a bad idea.
export var SoundFX;
(function (SoundFX) {
    SoundFX[SoundFX["SHUFFLE"] = 0] = "SHUFFLE";
    SoundFX[SoundFX["DEAL"] = 1] = "DEAL";
    SoundFX[SoundFX["SELECTION"] = 2] = "SELECTION";
    SoundFX[SoundFX["ELIMINATED"] = 3] = "ELIMINATED";
    SoundFX[SoundFX["TARGETED"] = 4] = "TARGETED";
})(SoundFX || (SoundFX = {}));
(function (Music) {
    function getPath(song) {
        var base = "assets/sounds/music/";
        var ext = ".mp3";
        return "" + base + Music.getName(song) + ext;
    }
    Music.getPath = getPath;
    function getName(song) {
        switch (song) {
            case Music.FULL_TEMPEST: return 'full-tempest';
            case Music.PANJSHIR: return 'panjshir';
            case Music.THE_HANDSOME_PRINCE: return 'the-handsome-prince';
            case Music.THE_QUEEN: return 'the-queen';
        }
    }
    Music.getName = getName;
    function getFromValue(key) {
        switch (key) {
            case 0: return Music.FULL_TEMPEST;
            case 1: return Music.PANJSHIR;
            case 2: return Music.THE_HANDSOME_PRINCE;
            case 3: return Music.THE_QUEEN;
        }
    }
    Music.getFromValue = getFromValue;
})(Music || (Music = {}));
